import { withDefaults } from "@warp-drive/legacy/model/migration-support";
import type { WithLegacy } from "@warp-drive/legacy/model/migration-support";
import { Type } from "@warp-drive/core/types/symbols";
import { derivation } from "../derivation";
import type OrganizationModel from "glesys-controlpanel/models/organization";

export type Invoice = WithLegacy<{
  currency: string;
  duedate: string;
  fullypaid: boolean;
  invoicedate: string;
  invoicenumber: string;
  paymentdate: string;
  remain: number;
  total: number;
  url: string;
  organization: OrganizationModel;
  isSettled: boolean;
  isCredit: boolean;
  [Type]: "invoice";
}>;

const isSettled = derivation<Invoice>("invoice:isSettled", (record) => record.remain === 0);

const isCredit = derivation<Invoice>("invoice:isCredit", (record) => record.total < 0);

const schema = withDefaults({
  type: "invoice",
  fields: [
    { kind: "attribute", name: "currency" },
    { kind: "attribute", name: "duedate" },
    { kind: "attribute", name: "fullypaid" },
    { kind: "attribute", name: "invoicedate" },
    { kind: "attribute", name: "invoicenumber" },
    { kind: "attribute", name: "paymentdate" },
    { kind: "attribute", name: "remain" },
    { kind: "attribute", name: "total" },
    { kind: "attribute", name: "url" },
    {
      kind: "belongsTo",
      name: "organization",
      type: "organization",
      options: { async: false, inverse: "invoices" },
    },
    { kind: "derived", name: "isSettled", type: "invoice:isSettled" },
    { kind: "derived", name: "isCredit", type: "invoice:isCredit" },
  ],
});

export const resource = {
  schema,
  derivations: [isSettled, isCredit],
};
